import {
  type MutationState,
  useMutation,
} from 'src/core/api/hooks/useMutation';

import { type CustomFieldPayload } from '../customField';

type CustomFieldResult = {
  result: {
    createdCustomFieldId: string;
    outcome: string;
  };
};

export const useCreateCustomFieldMutation = (): MutationState<
  CustomFieldPayload,
  CustomFieldResult
> => {
  return useMutation<CustomFieldPayload, CustomFieldResult, CustomFieldResult>({
    request: {
      type: 'rest',
      target: 'companyAPI',
      endpoint: '/custom-fields-package/custom-fields',
      method: 'post',
    },
    reshapeData: (data) => {
      return data;
    },
    options: {
      throwOnError: true,
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      onSuccess({ client }: any): void {
        client.invalidateQueries(['customFields']);
      },
    },
  });
};
